<template>
  <div class="gwnl-drawer-steps">
    <ul class="gwnl-drawer-steps__wrapper">
      <li
        v-for="(item, index) in steps"
        :key="index"
        class="step-item"
        :class="[current === index ? 'active' : '']"
      >
        <span
          v-if="current <= index"
          class="step-icon"
        >{{ index+1 }}</span>
        <span
          v-else
          class="step-icon yxt-icon-check"
        />
        <span
          class="step-title standard-size-14"
          :class="[current === index ? 'color-primary-6' : 'color-gray-9']"
        >{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DrawerSteps',
  props: {
    canPublish: Boolean,
    step: Number,
    needCheck: Boolean,
    stepsData: Array,
    sourceType: {
      type: Number
    }
  },
  data() {
    return {
      // steps: [
      //   {
      //     name: this.$t('pc_gwnl_eval_selectUtil')
      //   },
      //   {
      //     name: this.$t('pc_gwnl_lbl_setPlan')
      //   },
      //   {
      //     name: this.$t('pc_gwnl_eval_addPerson')
      //   },
      //   // 测训调用时标题为保存评估
      //   {
      //     name: this.$t('pc_gwnl_global_btn_saveEval')
      //   }
      // ]
    };
  },
  computed: {
    steps() {
      const setPlanStr = this.$t('pc_gwnl_lbl_setPlan');
      const stepsMap = {
        select: this.$t('pc_gwnl_eval_selectUtil'),
        info: setPlanStr,
        add: this.$t('pc_gwnl_eval_addPerson'),
        publish: this.canPublish ? this.$t('pc_gwnl_eval_publishEval') : this.$t('pc_gwnl_global_btn_saveEval'),
        multiInfo: setPlanStr,
        multiAdd: this.$t('pc_gwnl_eval_evalRelationship'),
        multiSave: this.$t('pc_gwnl_global_btn_saveEval')
      };
      return this.stepsData.map(id => {
        return {
          id,
          name: stepsMap[id] || stepsMap.publish
        };
      });
    },
    current() {
      return Math.min(this.steps.length - 1, this.step - 1);
    }
  }
};
</script>

<style scoped lang="scss">
.gwnl-drawer-steps {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  background-color: white;
  border-bottom: 1px solid #e9e9e9;
  z-index: 4;
}

.gwnl-drawer-steps__wrapper {
  display: flex;

  .step-item {
    position: relative;

    & + .step-item {
      margin-left: 24px;
    }
  }

  .active .step-icon {
    color: #fff;
    background: var(--color-primary-6);
  }

  .step-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    color: #8c8c8c;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    vertical-align: middle;
    background: #f0f0f0;
    border-radius: 50%;

    &.yxt-icon-check {
      color: #fff;
      font-size: 8px;
      background: #bdd2ff;
    }
  }

  .step-title {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
